/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useListCategoriesQuery } from "~/generated/graphql";

export function useCategoriesOptions(filterOut: string[] = []) {
  const { data, loading, error } = useListCategoriesQuery();

  const options =
    data?.listCategories?.categories
      ?.filter(({ name }) => !filterOut.includes(name))
      .map(({ id, name }) => ({
        value: id,
        label: name,
      })) ?? [];

  return {
    options,
    loading,
    error,
  };
}
